import {axiosWrapper} from 'Common/services/AxiosWrapper';
import {downloadResponse} from 'Common/helpers/downloadHelper';

const downloadRulesBackup = async (): Promise<void> => {
  const response = await axiosWrapper.get<void>(`/DownloadRulesBackup`, {responseType: 'blob'});
  downloadResponse(response, 'rules-backup');
};

export default {downloadRulesBackup};
